import script from "./ContentPageEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPageEdit.vue?vue&type=script&setup=true&lang=js"

import "./ContentPageEdit.vue?vue&type=style&index=0&id=b0dd8ea4&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0dd8ea4"]])

export default __exports__